import { isDefined } from "@clipboard-health/util-ts";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { useHistory } from "react-router-dom";

import { LoadingButton } from "../../components/LoadingButton";
import { SHIFT_DISCOVERY_IN_HOME_VISIT_CONFIRM_BOOKING_MODAL_PATH } from "../../ShiftDiscovery/paths";
import { useInHomeVisitModalsDataContext } from "../../ShiftDiscovery/useInHomeVisitModalsDataContext";

interface BookShiftButtonProps {
  visitId: string | undefined;
  caseId: string | undefined;
  isLoading: boolean;
  isMissingRequirements: boolean;
}

export function BookVisitButton(props: BookShiftButtonProps) {
  const { visitId, caseId, isLoading, isMissingRequirements } = props;

  const history = useHistory();
  const { generateModalPath } = useInHomeVisitModalsDataContext();

  const disabled = !isDefined(visitId) || !isDefined(caseId) || isMissingRequirements;

  return (
    <LoadingButton
      size="large"
      variant="contained"
      isLoading={isLoading}
      disabled={disabled}
      sx={{ minWidth: "30%" }}
      onClick={async () => {
        logEvent(APP_V2_USER_EVENTS.VISIT_DETAILS_CTA_BOOK_VISIT, { visitId });

        history.push(
          generateModalPath(SHIFT_DISCOVERY_IN_HOME_VISIT_CONFIRM_BOOKING_MODAL_PATH, {
            visitId: visitId!,
            caseId: caseId!,
          })
        );
      }}
    >
      {disabled ? "Can't book" : "Book"}
    </LoadingButton>
  );
}
